import AutocompleteField from "../../../shared/forms/AutocompleteField";
import CountryStateCitySelector from "../../../shared/common/CountryStateCitySelector";

import {
  genderOptions,
  profileForOptions,
} from "../../../shared/config/profileOptions";

import {
  deriveProfileFor,
} from "../utils/registrationBusinessRules";

const inputClass =
  "mt-1 block w-full rounded-xl border border-slate-300 bg-white px-3.5 py-2.5 text-sm text-slate-900 shadow-sm outline-none transition focus:border-amber-500 focus:ring-2 focus:ring-amber-500/20";

const Field = ({
  label,
  required = false,
  children,
}) => (
  <label className="block text-sm font-medium text-slate-700">
    <span>
      {label}
      {required && (
        <span className="ml-1 text-red-600">
          *
        </span>
      )}
    </span>
    {children}
  </label>
);

const BasicDetailsSection = ({
  formData,
  updateField,
  setFieldValue,
  searchMotherTongues,
  searchPlaces,
}) => {
  const genderLocked =
    formData.profileCreatedFor ===
      "Son" ||
    formData.profileCreatedFor ===
      "Daughter";

  const profileType =
    deriveProfileFor(
      formData.gender
    );

  const searchingFor =
    profileType === "Bridegroom"
      ? "Bride"
      : profileType === "Bride"
      ? "Bridegroom (Groom)"
      : "";

  return (
    <div className="space-y-6">
      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        <Field
          label="This Profile is For"
          required
        >
          <select
            name="profileCreatedFor"
            value={
              formData.profileCreatedFor
            }
            onChange={updateField}
            className={inputClass}
          >
            <option value="">
              -- Select --
            </option>
            {profileForOptions.map(
              (option) => (
                <option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </option>
              )
            )}
          </select>
        </Field>

        <Field
          label="Full Name (as per records)"
          required
        >
          <input
            name="name"
            value={formData.name}
            onChange={updateField}
            className={inputClass}
          />
        </Field>

        <AutocompleteField
          label="Mother Tongue"
          required
          value={
            formData.motherTongue
          }
          searchFn={
            searchMotherTongues
          }
          placeholder="Start typing mother tongue"
          onChange={(value) =>
            setFieldValue(
              "motherTongue",
              value
            )
          }
        />

        <div className="md:col-span-2 lg:col-span-3 grid gap-4 md:grid-cols-3">
          <CountryStateCitySelector
            formData={formData}
            handleChange={updateField}
            countryField="currentLocationCountry"
            stateField="currentLocationState"
            cityField="currentLocation"
            labelPrefix="Residing"
          />
        </div>

        <div>
          <div className="mb-2 text-sm font-medium text-slate-700">
            Gender
            <span className="ml-1 text-red-600">
              *
            </span>
          </div>

          <div
            className={`flex gap-5 rounded-xl border border-slate-300 bg-white px-4 py-3 ${
              genderLocked
                ? "opacity-70"
                : ""
            }`}
          >
            {genderOptions.map(
              (option) => (
                <label
                  key={option.value}
                  className="flex items-center gap-2 text-sm"
                >
                  <input
                    type="radio"
                    name="gender"
                    value={option.value}
                    checked={
                      formData.gender ===
                      option.value
                    }
                    disabled={
                      genderLocked
                    }
                    onChange={
                      updateField
                    }
                  />
                  {option.label}
                </label>
              )
            )}
          </div>

          {genderLocked && (
            <p className="mt-1.5 text-xs text-slate-500">
              Gender is auto-set based on “This Profile is For”.
            </p>
          )}
        </div>

        <Field label="How did you know about Kalyana Sakha?">
          <select
            name="howDidYouKnow"
            value={formData.howDidYouKnow || ""}
            onChange={updateField}
            className={inputClass}
          >
            <option value="">Select</option>
            {[
              "Online Advertisement",
              "Friend/Family Referral",
              "Social Media (Facebook, Instagram, etc.)",
              "Newspaper Advertisement",
              "Magazine Advertisement",
              "Event/Exhibition",
              "Walk-in/Office Visit",
              "Other",
            ].map((option) => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </Field>

        <div>
          <div className="mb-2 text-sm font-medium text-slate-700">Show My Profile</div>
          <p className="mb-2 text-xs text-slate-500">
            Choose whether your profile can appear in Search, Matches and profile discovery.
          </p>
          <div className="flex gap-5 rounded-xl border border-slate-300 bg-white px-4 py-3">
            <label className="flex items-center gap-2 text-sm">
              <input type="radio" name="shareDetailsOnPlatform" value="Yes"
                checked={(formData.shareDetailsOnPlatform || "Yes") === "Yes"}
                onChange={updateField} />
              Yes — Show my profile
            </label>
            <label className="flex items-center gap-2 text-sm">
              <input type="radio" name="shareDetailsOnPlatform" value="No"
                checked={formData.shareDetailsOnPlatform === "No"}
                onChange={updateField} />
              No — Hide my profile
            </label>
          </div>
        </div>
      </div>

      {formData.gender && (
        <div className="grid gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4 md:grid-cols-2">
          <div>
            <span className="text-sm font-medium text-slate-700">
              You are Registering for:
            </span>
            <div className="mt-1 text-base font-bold text-slate-900">
              {formData.gender ===
              "Male"
                ? "Bridegroom (Groom)"
                : "Bride"}
            </div>
          </div>

          <div>
            <span className="text-sm font-medium text-slate-700">
              Searching for Registered:
            </span>
            <div className="mt-1 text-base font-bold text-slate-900">
              {searchingFor}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BasicDetailsSection;
